import { IDiscountData } from "common/records/Discount";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_DISCOUNTS = "@discounts/RECEIVE_DISCOUNTS";
export const RECEIVE_DISCOUNT = "@discounts/RECEIVE_DISCOUNT";
export const REMOVE_DISCOUNT = "@discounts/REMOVE_DISCOUNT";
export const RESET_DISCOUNT = "@discounts/RESET_DISCOUNT";

export const DiscountActions = {
  receiveDiscount: (discount: Partial<IDiscountData>) => createAction(RECEIVE_DISCOUNT, discount),
  receiveDiscounts: (discounts: Partial<IDiscountData>[]) => createAction(RECEIVE_DISCOUNTS, { discounts }),
  removeDiscount: (discountId: number) => createAction(REMOVE_DISCOUNT, discountId),
  resetDiscount: (discountId: number) => createAction(RESET_DISCOUNT, discountId),
};

export type DiscountActions = ActionsUnion<typeof DiscountActions>;
